<template>
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>立候補ステータス</label>
        <dropdown v-model="searchForm.model.status" @change="search()">
          <option value="false">未立候補</option>
          <option value="true">立候補済み</option>
        </dropdown>
      </div>
    </div>
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical top loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <pagination :pager="pager" :callback="search"></pagination>
    <table class="tableLayout">
      <thead>
        <tr>
          <th style="width:15%">お問い合わせ日時</th>
          <th style="width:12%" class="center aligned">お問合せ番号</th>
          <th style="width:10%" class="center aligned">立候補件数</th>
          <th style="width:12%">ステータス</th>
          <th style="width:15%">希望日時</th>
          <th style="width:10%">人数</th>
          <th style="width:13%">一人当たりの予算</th>
          <th style="width:13%">希望条件など</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="marunage in marunages" :key="marunage.id">
          <td data-label="お問い合わせ日時">{{ marunage.created_at | formatDatetime }}</td>
          <td data-label="お問合せ番号" class="center aligned">{{ marunage.code }}</td>
          <td data-label="立候補件数" class="center aligned">{{ marunage.marunage_candidates.length }}件</td>
          <td data-label="ステータス">
            <span v-if="isReserved(marunage)" class="ui mini label">成約済み</span>
            <a v-else-if="candidatable(marunage)" :href="marunage.candidate_url">
              <button class="ui mini positive button">未立候補</button>
            </a>
            <a v-else :href="marunage.candidate_url">
              <span>立候補済み</span>
            </a>
          </td>
          <td data-label="希望日時">{{ marunage.event_date | formatDate }} {{ marunage.event_time }}</td>
          <td data-label="人数">{{ marunage.people_label }}</td>
          <td data-label="一人当たりの予算">{{ marunage.price_label }}</td>
          <td data-label="希望条件など"><div :title="marunage.note" class="ellipsis">{{ marunage.note | linebreakToSpace }}</div></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>

export default {
    data: function() {
        return {
            searchForm: this.createForm(_.defaults(this.query(), {
                status: 'false',
            })),
            pager: this.createPager(15, this.query().offset),
            marunages: []
        };
    },
    mounted: function() {
        this.search(this.pager.current());
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            this.replaceStateQuery(this.searchForm.model, ['limit']);
            return this.searchForm.get('/shopadmin/api/marunages', function(response) {
                this.marunages = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        },
        candidatable: function(marunage) {
            return !_.includes(marunage.marunage_candidates, window.data.shop_id);
        },
        isReserved: function(marunage) {
            return marunage.reservations.length > 0 && !_.includes(marunage.reservations, window.data.shop_id);
        }
    }
};
</script>
